import Box from '@mui/material/Box';
import type { CSSProperties } from 'react';

interface Props {
  size?: number;
  color?: string;
  style?: CSSProperties;
  variant?: string;
}

export default function UsersSvgIcon({ size = 20, color = 'currentColor', style }: Props) {
  return (
    <Box
      component="span"
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: size,
        height: size,
        color,
        '& svg': {
          width: '100%',
          height: '100%',
          display: 'block'
        }
      }}
      style={style}
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
        <defs>
          <clipPath clipPathUnits="userSpaceOnUse" id="usersIconClipPath">
            <path d="M 0,24 H 24 V 0 H 0 Z" />
          </clipPath>
        </defs>

        <g transform="matrix(1.3333333,0,0,-1.3333333,0,32)">
          <g clipPath="url(#usersIconClipPath)">
            <g transform="translate(4,15.5)">
              <path
                d="M 0,0 C 0,1.933 1.567,3.5 3.5,3.5 5.433,3.5 7,1.933 7,0 7,-1.933 5.433,-3.5 3.5,-3.5 1.567,-3.5 0,-1.933 0,0 Z"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="butt"
                strokeLinejoin="miter"
              />
            </g>

            <g transform="translate(1)">
              <path
                d="m 0,0 v 4 c 0,2.209 1.791,4 4,4 h 5 c 2.209,0 4,-1.791 4,-4 V 0"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="butt"
                strokeLinejoin="miter"
              />
            </g>

            <g transform="translate(14,19.5)">
              <path
                d="M 0,0 C 0,1.933 1.567,3.5 3.5,3.5 5.433,3.5 7,1.933 7,0 7,-1.933 5.433,-3.5 3.5,-3.5 1.567,-3.5 0,-1.933 0,0 Z"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="butt"
                strokeLinejoin="miter"
              />
            </g>

            <g transform="translate(15,12)">
              <path
                d="M 0,0 H 4 C 6.209,0 8,-1.791 8,-4 V -8"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="butt"
                strokeLinejoin="miter"
              />
            </g>
          </g>
        </g>
      </svg>
    </Box>
  );
}
